import $ from 'jquery';

const NumberService = {
    callback: {
        onchange: {},
    },
    getControl(id) {
        const control = $(`.control--${id}`);
        return {
            id,
            dom: {
                control,
                input: control.find('.control-number'),
            },
            config: {
                name: control.attr('data-name'),
                min: control.attr('data-min'),
                max: control.attr('data-max'),
                step: control.attr('data-step'),
            },
        };
    },
    onChange(id, callback) {
        if (!this.callback.onchange[id]) {
            this.callback.onchange[id] = [];
        }
        this.callback.onchange[id].push(callback);
    },
    triggerChange(id, value) {
        if (this.callback.onchange[id]) {
            this.callback.onchange[id].forEach((callback) => {
                callback(value);
            });
        }
    },
    getValue(id) {
        const control = this.getControl(id);
        const value = control.dom.input.val();

        return value !== '' ? +value : false;
    },
    setValue(id, value) {
        const controlObject = this.getControl(id);
        controlObject.dom.input.val(value || '');

        /*
            CHANGE
        */
        this.triggerChange(id, value);

        return {
            id,
            value
        };
    }
};
window.numberService = NumberService;
export default NumberService;
